<script setup>
import {
    ref,
    computed,
    onMounted,
    onBeforeUnmount
} from 'vue';
import tipsComponets from './components/tipsComponets'
import Sidebar from './components/Sidebar.vue'
import Navbar from './components/Navbar.vue'
import AppMain from './components/AppMain.vue'
import {
    useStore
} from 'vuex'

const store = useStore()
store.dispatch('user/getInfo')

const isMobile = ref(false)
const MOBILE_BREAKPOINT = 1024

// 移动端菜单显示状态
const mobileMenuVisible = ref(false)

// 检查屏幕宽度的函数
const checkScreenSize = () => {
    isMobile.value = window.innerWidth <= MOBILE_BREAKPOINT
}

// 监听窗口大小变化
const handleResize = () => {
    checkScreenSize()
    // 如果屏幕变大，自动关闭移动端菜单
    if (!isMobile.value) {
        mobileMenuVisible.value = false
    }
}

// 切换移动端菜单
const toggleMobileMenu = () => {
    mobileMenuVisible.value = !mobileMenuVisible.value
}

// 关闭移动端菜单
const closeMobileMenu = () => {
    mobileMenuVisible.value = false
}

onMounted(() => {
    store.dispatch('user/getInfo')
    checkScreenSize()
    window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
})

// 活动相关
const isActivity = computed(() => store.getters.isActivity);
</script>

<template>
    <div v-if="isActivity">
        <tipsComponets></tipsComponets>
    </div>
    <div class="app-wrapper" :style="{ paddingTop: isActivity ? '4.5rem' : '0' }">
        <Sidebar class="sidebar-container" :mobile-menu-visible="mobileMenuVisible" @close="closeMobileMenu" />
        <div class="main-container">
            <Navbar @toggle-mobile-menu="toggleMobileMenu" />
            <AppMain />
        </div>
    </div>
</template>

<style lang="less" scoped>
.app-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    position: fixed;
}

.sidebar-container{
    width: 22rem;
}

.main-container {
    height: 100vh;
    flex-grow: 1;
    width: calc(100% - 22rem);
    overflow: auto;
    background: #f8f8f8;
}
</style>